
$(function(){
$('.product_detail_top').contents().each(function () {
  if (this.nodeType === 3) { // テキストノード
    this.nodeValue = this.nodeValue.replace(/通常在庫/g, '他');
  } else {
    $(this).contents().each(arguments.callee);
  }
});

});